import React from "react"
import styled, { css } from "styled-components"
import Breakpoints from "../breakpoints"

interface ISectionDivider {
  flip?: boolean
  innerShadow?: boolean
  primaryColor?: string
  backgroundColor?: string
  sizes?: string[]
  className?: string
}

const Wrapper = styled.div<ISectionDivider>`
  display: ${(props) => (props.sizes.includes("sm") ? "block" : "none")};

  &,
  & * {
    box-sizing: border-box !important;
    margin: 0 !important;
  }

  @media (min-width: ${Breakpoints.md}) {
    display: ${(props) => (props.sizes.includes("md") ? "block" : "none")};
    width: 100%;
    height: 6.5vw;
    position: relative;
    z-index: 200;
    background-color: ${(props) => props.backgroundColor || "transparent"};

    border-bottom: 1px solid
      ${(props) => props.primaryColor || "rgba(40, 40, 40, 1)"};

    ${(props) =>
      props.flip &&
      css`
        transform: translate3d(0px, -1px, 0px) rotate3d(0, 0, 1, 180deg);
      `}
    & > div {
      position: absolute;
    }

    & > div:nth-child(1) {
      background: rgb(31, 31, 31);
      background: linear-gradient(
        to top right,
        ${(props) => props.primaryColor || "rgba(40, 40, 40, 1)"} 49.75%,
        rgba(255, 255, 255, 0) 50.25%
      );
      z-index: 20;
      top: 0;
      bottom: -1px;
      left: 0;
      right: 0;
    }
    & > div:nth-child(2) {
      background: rgb(31, 31, 31);
      background: linear-gradient(
        to top left,
        rgba(255, 255, 255, 1) calc(48% - 1px),
        rgba(100, 100, 100, 0.2) calc(48%),
        rgba(255, 255, 255, 0) 51%
      );

      z-index: 10;
      width: 115%;
      top: 0;
      bottom: 0;
      right: 0;
    }

    ::after {
      content: "";
      position: absolute;
      bottom: 0;
      width: 100%;
      z-index: 5;
      height: 5px;
      ${(props) =>
        props.innerShadow && "box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);"}
    }
  }

  @media (min-width: ${Breakpoints.lg}) {
    display: ${(props) => (props.sizes.includes("lg") ? "block" : "none")};
  }
`

const SectionDivider = ({
  flip = false,
  innerShadow = false,
  primaryColor,
  backgroundColor,
  sizes = ["md", "lg"],
  className,
}: ISectionDivider) => (
  <Wrapper
    flip={flip}
    innerShadow={innerShadow}
    primaryColor={primaryColor}
    backgroundColor={backgroundColor}
    sizes={sizes}
    className={className}
  >
    <div />
    <div />
  </Wrapper>
)

export default styled(SectionDivider)``
